import { Reducer } from "redux";

import { UserAction, UserActionTypes, UserState } from "./types";

const initialState: UserState = {
  defaultGateId: 0,
  availableGates: [],
  selectedGate: {
    id: 0,
    label: "",
    permissions: [],
  },
  username: "",
  userPermissions: [],
  permissions: [],
  isLoaded: false,
  isAdmin: false,
};

const reducer: Reducer<UserState, UserAction> = (state = initialState, action) => {
  switch (action.type) {
    case UserActionTypes.FETCH_REQUEST: {
      return { ...state, isLoaded: false };
    }

    case UserActionTypes.FETCH_ERROR: {
      return { ...state, isLoaded: false };
    }

    case UserActionTypes.FETCH_SUCCESS: {
      const { user, gateId } = action.payload;
      const defaultGateId = user.defaultGateId || 0;
      let selectedGate = user.availableGates.find((gate) => gate.id === gateId);
      if (!selectedGate) {
        selectedGate = user.availableGates.find((gate) => gate.id === defaultGateId);
      }
      if (user.isAdmin) {
        selectedGate = { ...state.selectedGate, id: gateId ?? defaultGateId };
      }
      const permissions = [...user.userPermissions, ...(selectedGate ? selectedGate.permissions : [])];
      return {
        ...state,
        ...user,
        defaultGateId,
        isLoaded: true,
        selectedGate: selectedGate ?? state.selectedGate,
        permissions,
      };
    }

    case UserActionTypes.SELECT_GATE: {
      const gateId = action.payload;
      const { availableGates, defaultGateId, userPermissions, isAdmin } = state;
      if (availableGates) {
        let selectedGate = availableGates.find((gate) => gate.id === gateId);
        if (selectedGate === undefined) {
          selectedGate = availableGates.find((gate) => gate.id === defaultGateId);
        }
        if (isAdmin) {
          selectedGate = { ...state.selectedGate, id: gateId ?? defaultGateId };
        }
        const permissions = [...userPermissions, ...(selectedGate ? selectedGate.permissions : [])];
        if (selectedGate && selectedGate.id === state.selectedGate.id) {
          return state;
        }
        return { ...state, selectedGate: selectedGate ?? state.selectedGate, permissions };
      }
      return state;
    }

    default:
      return state;
  }
};

export default reducer;
